import image01 from "../assets/png/events/ista.png";
import image02 from "../assets/png/events/able.png";
import image03 from "../assets/png/events/it-step.png";

export const event01 = {
  title: "Ista conference",
  image: image01,
  url: "https://istacon.org/",
};

export const event02 = {
  title: "Able mentor",
  image: image02,
  url: "https://www.ablebulgaria.org/en/project/able-mentor/",
};

export const event03 = {
  title: "IT step",
  image: image03,
  url: "https://itstep.bg/en",
};

export const events = [event01, event02, event03];
